import * as React from 'react';
import {CORES_DE_FUNDO} from './appAssetCrop';
import {BotaoAsset} from './AppAssetPresentation';

interface Props {
  cor: string;
  setCor: (cor: string) => void;
  processando: boolean;
}

export const AppAssetColorPicker = ({cor, setCor, processando}: Props) => (
  <>
    <div style={{fontSize: 13, marginBottom: 8, fontWeight: 600}}>
      Cor de fundo
    </div>
    <div
      role="group"
      aria-label="Cor de fundo"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        flexWrap: 'wrap',
      }}
    >
      {CORES_DE_FUNDO.map((c) => (
        <BotaoAsset
          key={c}
          type="button"
          aria-label={`Usar fundo ${c}`}
          disabled={processando}
          aria-pressed={cor === c}
          onClick={() => setCor(c)}
          style={{
            minHeight: 36,
            width: 36,
            padding: 4,
            outline: cor === c ? '2px solid #1264b9' : undefined,
            outlineOffset: 2,
          }}
        >
          <span
            style={{
              display: 'block',
              background: c,
              height: 24,
              borderRadius: 5,
              border: '1px solid #20314522',
            }}
          />
        </BotaoAsset>
      ))}
      <label style={{display: 'flex', gap: 8, alignItems: 'center'}}>
        Outra cor
        <input
          type="color"
          disabled={processando}
          aria-label="Escolher outra cor de fundo"
          value={cor}
          onChange={(e) => setCor(e.target.value)}
          style={{
            width: 38,
            height: 36,
            padding: 2,
            border: '1px solid #c9d5e2',
            background: '#fff',
            borderRadius: 7,
          }}
        />
      </label>
    </div>
  </>
);
